import { l as r } from "./length-of-array-like.js";
import { t as o } from "./to-integer-or-infinity.js";
var t = RangeError,
  a = function a(_a, i, n, e) {
    var f = r(_a),
      s = o(n),
      m = s < 0 ? f + s : s;
    if (m >= f || m < 0) throw t("Incorrect index");
    for (var c = new i(f), g = 0; g < f; g++) c[g] = g === m ? e : _a[g];
    return c;
  };
export { a };